<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('manifests.manifestNumber')"
    class="manifest-number-filter w-2"
    optional
  >
    <InputText
      :id="inputId"
      v-model="internalValue.manifestNumber"
      :placeholder="t('manifests.manifestNumber')"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ManifestSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import InputText from 'primevue/inputtext';

const internalValue = defineModel({
  type: Object as PropType<ManifestSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
